import React from 'react'
import { NavLink } from '../../lib/Navigation'

export default function CommunityType(props) {

  const { circles_info, topic_id } = props

  return (
    <NavLink to={'/gameCommunity?topic_id=' + topic_id + '&circles_type=' + circles_info.circles_type} style={{ display: 'inline-block', paddingTop: '13px' }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '1px 7.5px', borderRadius: '12px', backgroundColor: '#F3F9FF' }}>
        <img style={{ display: 'block', height: 12 }} src="resources/251009/community_info-icon.png" alt="" />
        <div style={{ fontSize: '0.24rem', color: '#666', padding: '0 6px' }}>{circles_info?.name}</div>
      </div>
    </NavLink>
  )
}
